import React from "react";

const SearchResult = ({ results }) => {
    return (
        <div className="w-[100%] mt-[40px] border-[1px] border-solid border-[#C9CED2] rounded-[16px]">
            <div className="w-[100%] text-[#4B535B] text-[16px] flex items-center gap-[50px] py-[20px] px-[24px] bg-[#EFF0F2] rounded-t-[16px]">
                <div className="sm:min-w-[145px] w-[100px]">Код ТН ВЭД 2022</div>
                <div>Описание</div>
            </div>
            
                {results.map((item, index) => (
                    <div key={index} className="searchTable w-[100%] text-[#1F2225] text-[14px] sm:text-[16px] flex items-center gap-[50px] py-[20px] px-[24px]">
                        <div className="sm:min-w-[145px] w-[100px]">{item.tnved}</div>
                        <div className="max-w-[80%] leading-[1.3]">{item.desc || item.name}</div>
                    </div>
                ))
             }
        </div>
    );
};

export default SearchResult;
